import { MESSAGE_ALGO_SALIO_MAL, show_popup, TITLE_ERROR } from '@shared/utility/popup-error';
import { MonoTypeOperatorFunction } from 'rxjs';
import { delay as delayOperator, retryWhen, scan, tap } from 'rxjs/operators';

export function retryWithDelay<T>(delay: number, count = 1): MonoTypeOperatorFunction<T> {
  return (input) =>
    input.pipe(
      retryWhen((errors) =>
        errors.pipe(
          scan((acc, error) => ({ count: acc.count + 1, error }), {
            count: 0,
            error: undefined as any,
          }),
          tap((current) => {
            if (current.count > count) {
              // show_popup(TITLE_ERROR, MESSAGE_ALGO_SALIO_MAL);
              throw current.error;
            }
          }),
          delayOperator(delay)
        )
      )
    );
}

export function retryLoginWithDelay<T>(delay: number, count = 1): MonoTypeOperatorFunction<T> {
  return (input) =>
    input.pipe(
      retryWhen((errors) =>
        errors.pipe(
          scan((acc, error) => ({ count: acc.count + 1, error }), {
            count: 0,
            error: undefined as any,
          }),
          tap((current) => {
            if (current?.error?.error?.status == 400 || current.count > count) {
              throw current.error;
            }
          }),
          delayOperator(delay)
        )
      )
    );
}
